import React from 'react';
import { graphql } from 'gatsby';

import Website from 'components/ui-setup';
import Layout from 'components/layout';
import Careers from 'components/careers';

type Props = {
  data: Object,
};

const CareersPage = ({ data }: Props) => {
  const {
    careersJson,
    currentOpeningsJson,
    siteJson,
    logoJson,
    socialMediaJson,
    cookieConsentJson,
    companyBadgesJson,
  } = data;

  return (
    <Website
      content={{
        ...careersJson,
        currentOpenings: currentOpeningsJson,
        cookieConsent: cookieConsentJson,
        menu: siteJson?.content,
        logo: logoJson,
        socialMedia: socialMediaJson,
        companyBadges: companyBadgesJson,
      }}>
      <Layout>
        <Careers />
      </Layout>
    </Website>
  );
};

export default CareersPage;

export const query = graphql`
  query CareersPageQuery {
    careersJson {
      hero {
        background {
          image {
            xl
            lg
            md
            sm
            xs
          }
        }
        title
      }
      life {
        title
        subtitle
        text
        buttonLabel
        buttonLink
      }
      achieve {
        title
        cards {
          id
          title
          content
          image
          imageSize
        }
      }
      slider {
        images {
          xl
          lg
          md
          sm
          xs
        }
      }
      meta {
        description
        title
      }
    }
    siteJson {
      ...SiteJsonFragment
    }
    currentOpeningsJson {
      ...CurrentOpeningsJsonFragment
    }
    cookieConsentJson {
      ...CookieConsentJsonFragment
    }
    logoJson {
      ...LogoJsonFragment
    }
    socialMediaJson {
      ...SocialMediaJsonFragment
    }
    companyBadgesJson {
      ...CompanyBadgesJsonFragment
    }
  }
`;
